import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading || user === null) {
    return (
      <div
        data-testid="admin-loading"
        className="min-h-screen flex items-center justify-center bg-[#F3F1EB]"
      >
        <Loader2 className="h-8 w-8 animate-spin text-[#3A4A38]" />
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
